import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

export interface PageHeaderProps {
  /** Mala etykieta nad tytulem, np. „1. TWORZENIE TURNIEJU”. */
  eyebrow?: ReactNode;
  title: ReactNode;
  /** Zdanie opisujace ekran, pod tytulem. */
  description?: ReactNode;
  /** Akcje po prawej stronie (przyciski, przelaczniki). */
  actions?: ReactNode;
  className?: string;
}

/** Naglowek ekranu — powtarzalny uklad z makiet. */
export function PageHeader({ eyebrow, title, description, actions, className }: PageHeaderProps) {
  return (
    <header className={cn('flex flex-wrap items-start justify-between gap-4', className)}>
      <div className="min-w-0">
        {eyebrow && (
          <p className="text-brand-text mb-1.5 text-xs font-bold tracking-[0.08em] uppercase">
            {eyebrow}
          </p>
        )}
        <h1 className="text-fg-strong text-3xl font-extrabold tracking-[-0.03em]">{title}</h1>
        {description && <p className="text-fg-muted mt-1.5 text-sm">{description}</p>}
      </div>

      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </header>
  );
}
